export default{
    __bsi_SeeAll:"Login to See All",
    __asi_SeeAll:"See All",
    __CasinoSectionTitle: "Live Casino"
}